export const clientPortalInviteUserFormValidation = {
  selectedContactId: {
    type: 'string',
    required: true,
  },
  isNewContact: {
    type: 'boolean',
    required: false,
  },
  firstName: {
    type: 'string',
    required: true,
  },
  lastName: {
    type: 'string',
    required: true,
  },
  email: {
    type: 'string',
    required: true,
    email: true,
  },
  accessUntil: {
    type: 'string',
    required: true,
  },
};
